import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FieldControlMaster} from '../control-master-label-required';
import {FieldConfigName} from '../../../models';
import {SvcCmpInputDialogComponent} from './svc-cmp-input-dialog.component';


@Component({
  selector: 'app-svc-cmp-input',
  templateUrl: './svc-cmp-input.component.html',
  styleUrls: ['./svc-cmp-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SvcCmpInputComponent extends FieldControlMaster implements OnInit {
  @Output() svcCmpInputUpdateControl = new EventEmitter<{ control: FieldConfigName, index: number }>();
  @Output() svcCmpInputDelete = new EventEmitter<number>();
  dialogComponent = SvcCmpInputDialogComponent;
  placeholder = 'Sélectionner une valeur';
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.placeholder = this.control.options.placeholder || this.placeholder;
  }
  onUpdatedControl(object) {
    this.svcCmpInputUpdateControl.emit(object);
  }
  onDeletedControl(index: number) {
    this.svcCmpInputDelete.emit(index);
  }
}
